import { NgModule } from '@angular/core';
import { S1dbgS1dbm01Component } from './s1dbg-s1dbm01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S1dbgS1dbm01Component]
})
export class S1dbgModule { }

